import { render } from "./frontConfirm.vue?vue&type=template&id=ada63284&scoped=true"
import script from "./frontConfirm.vue?vue&type=script&lang=js"
export * from "./frontConfirm.vue?vue&type=script&lang=js"

import "./frontConfirm.vue?vue&type=style&index=0&id=ada63284&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada63284"]])

export default __exports__